export function mapBoardKeymapToMatrixNames(keymap, numRows, numCols) {
  if (!Array.isArray(keymap)) {
    throw new Error('Keymap must be an array')
  }

  if (typeof numRows !== 'number' || numRows < 1 || numRows > 10) {
    throw new Error('Number of rows must be between 1 and 10')
  }

  if (typeof numCols !== 'number' || numCols < 1 || numCols > 40) {
    throw new Error('Number of columns must be between 1 and 40')
  }

  const numNormalKeys = numRows * numCols
  
  if (keymap.length < numNormalKeys) {
    throw new Error(`Keymap too short: expected at least ${numNormalKeys} keys, got ${keymap.length}`)
  }

  const numThumbKeys = keymap.length - numNormalKeys
  const thumbValues = keymap.slice(-numThumbKeys)

  const columns = []
  for (let col = 0; col < numCols; col++) {
    const column = []
    for (let row = numRows - 1; row >= 0; row--) {
      const index = row * numCols + col
      column.push(keymap[index])
    }
    columns.push(column)
  }

  const transformedKeymap = {}

  columns.forEach((col, colIndex) => {
    col.forEach((key, rowIndex) => {
      transformedKeymap[`matrix_col${colIndex}_row${rowIndex}`] = key
    })
  })

  thumbValues.forEach((key, index) => {
    transformedKeymap[`thumbs_thumb${index + 1}_cluster`] = key
  })

  return transformedKeymap
}

export function getKeycapLegend(positionName, keyMap) {
  if (!keyMap || typeof keyMap !== 'object') {
    throw new Error('Invalid keyMap provided')
  }

  if (typeof positionName !== 'string') {
    throw new Error('Position name must be a string')
  }

  return keyMap[positionName] || ''
}